import '@rentflowdev/ui/styles.css'
import './lib/i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { configureAuthStorage } from '@rentflowdev/api'
import { router } from './router'
import { clearTokens, getAccessToken, getRefreshToken, setTokens } from './lib/auth'
import './index.css'

// Wire @rentflowdev/api baseQuery to the web's existing token storage
configureAuthStorage({
	getAccessToken,
	getRefreshToken,
	setTokens,
	clearTokens,
})

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
)
